export enum CardBackgroundRepollState {
  Pending = `pending`,
  Ready = `ready`,
  None = `none`,
}
